module.exports = __webpack_public_path__ + "img/paper-bag-3.47d65406.png";